<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#7bff76" type="square-loader" [fullScreen]="false">
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="content-wrapper">
    <div class="card ">
        <div class="card-header bg-danger">
            <div style="float: left;">
                <h2><i class="fa fa-users"></i>ข้อมูลปริมาณอ้อยเข้าหีบสะสมโดยรถตัด</h2>
            </div>

            <div style="float: right;">
                <table class="table-warning">
                    <td>
                        <mat-form-field appearance="fill">
                            <mat-label>เลือกช่วงวันที่</mat-label>
                            <mat-date-range-input [rangePicker]="picker" disabled color="accent">
                                <input matStartDate [(ngModel)]="dateS.date1" min="{{date.date1}}"
                                    placeholder="เริ่มวันที่">
                                <input matEndDate [(ngModel)]="dateS.date2" min="{{date.date2}}"
                                    placeholder="ถึงวันที่">
                            </mat-date-range-input>
                            <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        </mat-form-field>
                    </td>
                    <td>
                        <button mat-raised-button color="primary" (click)="LoadCanebyCutcar()">ค้นหา</button>
                    </td>
                </table>
                <!--
                <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon2">จากวันที่</span>
                    <input type="date" class="form-control" [(ngModel)]="dateS.date1" min="{{date.date1}}"
                        max="{{date.date2}}">
                    <span class="input-group-text" id="basic-addon2">ถึงวันที่</span>
                    <input type="date" class="form-control" [(ngModel)]="dateS.date2" min="{{date.date1}}"
                        max="{{date.date2}}">
                    <button class="btn btn-info" (click)="LoadCanebyCutcar()">ค้นหา / โหลดใหม่</button>
                </div>-->
            </div>
        </div>
        <div class="card-body">
            <table class="table table-sm">
                <tr>
                    <td style="text-align:left">
                        <button class="btn btn-outline-success" (click)="ExportExcel();" *ngIf="bycarcut.length>0">
                            <i class="fas fa-download"></i>Download Excel
                        </button>
                    </td>
                    <td style="text-align:right">
                        <label *ngIf="choosedate.length>0">วันที่เลือก : {{choosedate}}</label>
                    </td>
                </tr>
            </table>
            <hr>
            <div class="table-responsive" style="height: 600px;">
                <table class="table table-head-fixed table-striped table-hover text-nowrap table-sm" #table>
                    <thead>
                        <tr style="text-align: center;">
                            <th>#</th>
                            <th scope="col">โซน</th>
                            <th scope="col">รหัสกลุ่ม</th>
                            <th scope="col">ชื่อหน.กลุ่ม</th>
                            <th scope="col">ประเภทกลุ่ม</th>
                            <th scope="col" class="bg-danger">กำลังตัดต่อวัน</th>
                            <th scope="col">เกรด</th>
                            <th scope="col">พื้นที่(ไร่)</th>
                            <th scope="col">ประเมิน</th>
                            <th scope="col">จำนวนเที่ยว</th>
                            <th scope="col">อ้อยเข้าหีบ</th>
                            <th scope="col">%อ้อยเข้า</th>
                            <th scope="col">อ้อยคงเหลือ</th>
                            <th scope="col">อ้อยเข้าวันนี้</th>
                            <th scope="col" class="bg-warning">เป้าต่อวัน</th>
                            <th scope="col" class="bg-success">% เข้าวันนี้</th>
                            <th scope="col">อ้อยรอในลาน</th>
                            <th scope="col" class="bg-info">อ้อยเข้าช่วงวันที่เลือก</th>
                            <th scope="col" class="bg-info">CCS ช่วงวันที่เลือก</th>
                            <th scope="col" class="bg-primary">CCS สะสม </th>

                            <th scope="col">อ้อยสด</th>
                            <th scope="col">%อ้อยสด</th>
                            <th scope="col">พื้นที่ตัดเสร็จ</th>
                            <th scope="col">อ้อยประเมิน</th>
                            <th scope="col">ผลผลิตแปลงตัดเสร็จ</th>

                            <th scope="col">คาดวันที่แล้วเสร็จ</th>
                        </tr>

                    </thead>
                    <tbody>
                        <tr *ngFor="let item of bycarcut; let i = index;">
                            <td>{{i+1}}</td>
                            <td>{{item.supzone}}</td>
                            <td>{{item.groupcode}}</td>
                            <td>{{item.h_fmname}}</td>
                            <td class="text-center">
                                <label *ngIf="item.qtype == 1">คนตัด</label>
                                <label *ngIf="item.qtype == 2">รถโยน</label>
                                <label *ngIf="item.qtype == 3">รถตัด</label>
                            </td>
                            <td class="text-right">{{item.canePerDay | number}}</td>
                            <!-- กำลังตัดต่อวัน -->
                            <td class="text-right">{{item.grade}}</td> <!-- GRADE -->
                            <td class="text-right">{{item.area | number:'1.1-2'}}</td> <!-- พื้นที่ -->
                            <td class="text-right">{{item.assess | number:'1.1-2'}}</td> <!-- ประเมิน -->
                            <td class="text-right">{{item.cnt_all | number}}</td> <!-- จำนวนเที่ยว -->
                            <td class="text-right">{{item.canein | number:'1.1-2'}}</td> <!-- อ้อยเข้าหีบ -->
                            <td class="text-right">{{item.pccanein | number:'1.1-2'}}</td>
                            <td class="text-right">{{item.caneleft | number:'1.1-2'}}</td> <!-- อ้อยคงเหลือ -->
                            <td class="text-right">{{item.caneindate | number:'1.1-2'}}</td>
                            <!-- อ้อยเข้าวันนี้	 -->
                            <td class="text-center">{{item.canetargetDate | number:'1.1-2'}}</td> <!-- เป้าต่อวัน -->
                            <td class="text-center">{{item.pccanetargetDate | number:'1.1-2'}}</td>
                            <!-- % เข้าวันนี้ -->
                            <td class="text-right">{{item.canewaitbrr | number:'1.1-2'}}</td> <!-- อ้อยรอในลาน -->
                            <td class="text-right">{{item.canein_be | number:'1.1-2'}}</td>
                            <!-- Canein Choose Time	 -->
                            <td class="text-right">{{item.ccs_be | number:'1.1-2'}}</td>
                            <!-- CCS Choose Time	 -->
                            <td class="text-right"> {{item.ccs | number:'1.1-2'}}</td> <!-- CCS สะสม -->

                            <td class="text-right">{{item.caneinFresh | number:'1.1-2'}}</td> <!-- อ้อยสด	 -->
                            <td class="text-right">{{item.pccaneFresh | number:'1.1-2'}}</td>
                            <td class="text-right">{{item.areacuted | number:'1.1-2'}}</td>
                            <!-- พื้นที่ตัดเสร็จ -->
                            <td class="text-right">{{item.assesscuted | number:'1.1-2'}}</td>
                            <!-- อ้อยประเมินพื้นที่ตัดเสร็จ -->
                            <td class="text-right">{{item.yieldCuted | number:'1.1-2'}}</td>
                            <!-- ผลผลิตแปลงตัดเสร็จ -->

                            <td>{{item.dateFinish}}</td> <!-- คาดวันที่แล้วเสร็จ -->
                        </tr>

                        <tr class="table-success under" *ngFor="let item of sumallbygroup">
                            <td colspan="5" class="text-right">+++ รวม +++</td>
                            <td class="text-right">{{item.sumcanePerDay | number}}</td>
                            <!-- กำลังตัดต่อวัน -->
                            <td class="text-right"></td> <!-- GRADE -->
                            <td class="text-right">{{item.sumarea | number:'1.1-2'}}</td> <!-- พื้นที่ -->
                            <td class="text-right">{{item.sumassess | number:'1.1-2'}}</td><!-- ประเมิน -->
                            <td class="text-right">{{item.sumcnt_all | number}}</td> <!-- จำนวนเที่ยว -->
                            <td class="text-right">{{item.sumcanein | number:'1.1-2'}}</td> <!-- อ้อยเข้าหีบ -->
                            <td class="text-right">{{item.sumpccanein | number:'1.1-2'}}</td>
                            <!-- % อ้อยเข้าหีบ -->
                            <td class="text-right">{{item.sumcaneleft | number:'1.1-2'}}</td>
                            <!-- อ้อยคงเหลือ -->
                            <td class="text-right">{{item.sumcaneindate | number:'1.1-2'}}</td>
                            <!-- อ้อยเข้าวันนี้	 -->
                            <td class="text-right">{{item.sumcanetargetDate | number:'1.1-2'}}</td>
                            <!-- เป้าต่อวัน -->
                            <td class="text-right">{{item.sumpccaneintoday | number:'1.1-2'}}</td>
                            <!-- % เข้าวันนี้ -->
                            <td class="text-right">{{item.sumcanewaitbrr | number:'1.1-2'}}</td>
                            <!-- อ้อยรอในลาน -->
                            <td class="text-right">{{item.sumcaneinchoose | number:'1.1-2'}}</td>
                            <!--  อ้อยเข้าหีบช่วงเวลาที่เลือก	 -->
                            <td class="text-right">{{item.sumccsinchoose | number:'1.1-2'}}</td>
                            <!--  CCS ช่วงเวลาที่เลือก -->
                            <td class="text-right">{{item.sumccs | number:'1.1-2'}}</td><!-- CCS สะสม -->

                            <td class="text-right">{{item.sumcaneinFresh | number:'1.1-2'}}</td> <!-- 	อ้อยสด -->
                            <td class="text-right"></td>
                            <td class="text-right">{{item.sumareacuted | number:'1.1-2'}}</td>
                            <!-- พื้นที่ตัดเสร็จ -->
                            <td class="text-right">{{item.sumassesscuted | number:'1.1-2'}}</td>
                            <!-- อ้อยประเมินพื้นที่ตัดเสร็จ -->
                            <td class="text-right">{{item.sumyieldCuted | number:'1.1-2'}}</td>
                            <!-- ผลผลิตแปลงตัดเสร็จ -->

                            <td class="text-right"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>